import {
  GetAccountHoldersListBody,
  GetAccountHoldersListResponse,
  getClientList,
} from "../../../services/accountService";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

export default function useClientsQuery(
  params: GetAccountHoldersListBody,
  queryOptions?: UseQueryOptions<GetAccountHoldersListResponse, string>
) {
  return useQuery<GetAccountHoldersListResponse, string>(
    ["clients", params],
    () => getClientList(params),
    {
      ...queryOptions,
    }
  );
}
